import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import apiClient from "../../utils/apiClient";

const UserView = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [user, setUser] = useState(null);

  useEffect(() => {
    apiClient.get(`/auth/users/${id}/`).then((res) => setUser(res.data.data));
  }, [id]);

  if (!user) return <p>Loading...</p>;

  return (
    <div className="user-view-card">
      <h2>User Details</h2>
      {Object.entries(user).map(([k, v]) => (
        <p key={k}><b>{k}</b>: {String(v)}</p>
      ))}
      <button onClick={() => navigate("/users")}>Close</button>
    </div>
  );
};

export default UserView;
